import { handleActions, createAction } from 'redux-actions';
import { navigationMapping } from '../consts/navigation';
import history from '../store/history';

export const SET_VEHICLE_TYPE = createAction('SET_VEHICLE_TYPE');
export const SET_VEHICLE_TYPE_NO_EFFECT = createAction('SET_VEHICLE_TYPE_NO_EFFECT')
export const FETCH_NEW_OFFERS_COUNT = createAction('FETCH_NEW_OFFERS_COUNT');
export const FETCH_NEW_OFFERS_COUNT_SUCCESS = createAction('FETCH_NEW_OFFERS_COUNT_SUCCESS');
export const FETCH_NEW_OFFERS_COUNT_FAIL = createAction('FETCH_NEW_OFFERS_COUNT_FAIL');

const initialState = {
  vehicleType: window.localStorage.getItem('vehicle_type') || 'Motorbike',
  new_motorbikes: 0,
  new_campers: 0,
  new_agricultural_machines: 0,
};

const vehicleTypeReducer = handleActions(
  {
    [SET_VEHICLE_TYPE]: (state, { payload, }) => {
      window.localStorage.setItem('vehicle_type', payload)
      history.push({
        pathname: navigationMapping.browse.table_url,
      });
      return { ...state, vehicleType: payload, };
    },
    [SET_VEHICLE_TYPE_NO_EFFECT]: (state, { payload, }) => {
      return { ...state, vehicleType: payload, };
    },
    [FETCH_NEW_OFFERS_COUNT_SUCCESS]: (state, { payload, }) => {
      return { ...state, ...payload, }
    },
  },
  initialState
);

export default vehicleTypeReducer;
